export const Progressbar = (Splide, Components, options) => {
    const { root } = Components.Elements;
    const { Controller } = Components;

    let el, controls;

    function mount() {
        controls = root.querySelector(".splide__controls");

        if (!controls) return;

        el = controls.querySelector(".splide__progress-bar");

        if (!el) {
            return;
        }

        update();

        Splide.on("move resized", update);
    }

    function update() {
        if (!el) return;

        let end = Controller.getEnd() + 1;
        let rate = Math.min((Splide.index + 1) / end, 1);

        el.style.width = String(100 * rate) + "%";
    }

    return {
        mount,
    };
};
